import * as React from "react";
const SvgFiRrChess = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-chess_svg__a)">
      <path
        fill="#062147"
        d="M24 21a3 3 0 0 1-3 3h-5a1 1 0 0 1 0-2h5a1 1 0 0 0 1-1 .96.96 0 0 0-1.02-1H17a1 1 0 0 1 0-2h3v-7h-4v6a1 1 0 0 1-2 0v-6.269A2 2 0 0 1 13 9V8a1 1 0 1 1 2 0v1h2V8a1 1 0 1 1 2 0v1h2V8a1 1 0 1 1 2 0v1a2 2 0 0 1-1 1.731v7.444A2.94 2.94 0 0 1 24 21m-10 0a3 3 0 0 1-3 3H3a3 3 0 0 1-.766-5.9A42 42 0 0 0 3.974 9a1 1 0 0 1-.7-1.691S2.27 5.748 2.25 5.707A2.6 2.6 0 0 1 4.6 2h1.41V1a1 1 0 0 1 2 0v1H9.4a2.6 2.6 0 0 1 2.352 3.707c-.019.041-1.029 1.6-1.029 1.6A1 1 0 0 1 10.027 9c.246 3.088.83 6.14 1.74 9.1A3 3 0 0 1 14 21M5.976 9a42 42 0 0 1-1.625 9h5.3a42.2 42.2 0 0 1-1.626-9zM4.04 4.807l1.4 2.16.021.033h3.08l.02-.033 1.4-2.16A.6.6 0 0 0 9.401 4H4.6a.59.59 0 0 0-.507.278.6.6 0 0 0-.054.529M12 21a1 1 0 0 0-1-1H3a1 1 0 0 0 0 2h8a1 1 0 0 0 1-1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-chess_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrChess;
